import { useEffect, useState } from 'react';
import { SessionJob, sessionJobStates } from '../../services/jobs';

const useSessionJobs = (sessionId: string) => {
  const [jobs, setJobs] = useState<SessionJob[]>(sessionJobStates.jobs[sessionId] ?? []);

  useEffect(() => {
    setJobs(sessionJobStates.jobs[sessionId] ?? []);

    return sessionJobStates.addHandler(sessionId, setJobs);
  }, [sessionId]);

  return jobs;
};

export const isActive = (job: SessionJob) => !job.finishState && job.state !== 'Done';

export const toPercent = (job: SessionJob) => Math.round((job.progress ?? 0) * 100);

export default useSessionJobs;
